import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { FacultyRestrictionItem } from '../../types';
import { RestrictionReset } from './types';
import {
  GENERIC_UNIT,
  RESTRICTION_UNITS,
} from '../../../../../../constants/restriction';

@Component({
  selector: 'app-faculties-selection-list-restriction-form',
  templateUrl: './faculties-selection-list-restriction-form.component.html',
  styleUrl: './faculties-selection-list-restriction-form.component.scss',
})
export class FacultiesSelectionListRestrictionFormComponent
  implements OnInit, OnDestroy
{
  @Input() restriction: FacultyRestrictionItem;
  @Output() resetRestriction = new EventEmitter<RestrictionReset>();

  restrictionUnitOptions = RESTRICTION_UNITS.map(({ type, values }) => ({
    label: type,
    options: values.map(({ displayName, value }) => ({
      label: displayName,
      value,
      disabled:
        value === GENERIC_UNIT.LOCALITY ||
        value === GENERIC_UNIT.EXPIRATION_DATE,
    })),
  }));

  private unitSubscription: Subscription;

  get isNonEditableRestriction(): boolean {
    const unitValue = this.restriction.controls.unit.value;
    return (
      unitValue === GENERIC_UNIT.EXPIRATION_DATE ||
      unitValue === GENERIC_UNIT.LOCALITY
    );
  }

  ngOnInit() {
    this.unitSubscription =
      this.restriction.controls.unit.valueChanges.subscribe((selectedUnit) => {
        if (selectedUnit) {
          const defaultValue = this.findDefaultValueByUnitValue(selectedUnit);
          this.restriction.controls.value.setValue(defaultValue);
          // Actualizar estado editable cuando cambia la unidad
          this.updateControlsEditableState();
        }
      });
  }

  private updateControlsEditableState(): void {
    if (this.isNonEditableRestriction) {
      this.restriction.controls.unit.disable({ emitEvent: false });
      this.restriction.controls.value.disable({ emitEvent: false });
    } else {
      // Solo habilitar si el FormGroup padre no está disabled
      if (!this.restriction.disabled) {
        this.restriction.controls.unit.enable({ emitEvent: false });
        this.restriction.controls.value.enable({ emitEvent: false });
      }
    }
  }

  findDefaultValueByUnitValue(unitValue: string | number): string {
    for (const group of RESTRICTION_UNITS) {
      const valueObj = group.values.find((v) => v.value === unitValue);

      if (valueObj) {
        return valueObj.defaultValue;
      }
    }
    return '';
  }

  ngOnDestroy() {
    if (this.unitSubscription) {
      this.unitSubscription.unsubscribe();
    }
  }
}
